module.exports = __webpack_public_path__ + "static/media/reel.2a7b4308.png";